import { css } from 'styled-components'

import { Primary, Secondary } from './newColor'
import { textSize } from './text'
import { viewport } from './viewport'

const articleStyle = css`
  color: ${Secondary};
  font-family: 'Noto Sans TC', 'PingFang TC', 'HeiTi TC', 'Microsoft JhengHei', 'sans-serif';
  font-size: ${textSize.h4Web}px;
  font-weight: 300;

  @media (max-width: ${viewport.tablet}px) {
    font-size: 14px;
  }

  @media (min-width: ${viewport.tablet + 1}px) {
    font-size: 16px;
  }

  & > * {
    letter-spacing: 1.1px;
    margin: 0;
  }
  ol,
  ul {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  ul {
    list-style-type: disc;
  }
  ol {
    list-style-type: decimal;
  }
  h2,
  h3,
  h4 {
    font-weight: 500;
    margin: 8px auto;
    line-height: normal;
    color: ${Secondary};
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 16px;
  }
  p {
    line-height: 2;
  }
  strong {
    font-weight: bold;
    color: ${Secondary};
  }
  a {
    color: ${Secondary};
    font-weight: 400;
    text-decoration: underline ${Secondary};

    &:active,
    &:focus {
      color: ${Primary};
    }
    &:hover {
      color: ${Primary};
    }
  }
  table {
    border-collapse: collapse;
    border-style: solid;
    border: 1px solid #bbb;
  }
  tr {
    vertical-align: middle;
  }
  td {
    border: 1px dashed #bbb;
    padding: 16px;
  }
`

const articleStyleInEditorContentStyle = `
  * {
    letter-spacing: 1.1px;
    margin: 0;
    color: ${Secondary};
    font-weight: 200;
  }
  p {
    color: ${Secondary};
    font-family: 'Noto Sans TC', 'PingFang TC', 'HeiTi TC', 'Microsoft JhengHei', 'sans-serif';
    font-size: ${textSize.h4Web}px;
  }

  @media (max-width: ${viewport.tablet}px) {
    font-size: 14px;
  }

  @media (min-width: ${viewport.tablet + 1}px) {
    font-size: 16px;
  }
  h2,
  h3,
  h4 {
    font-weight: bold;
    margin: 8px auto;
    line-height: normal;
  }
  h2 {
    font-size: 22px;
  }
  h3 {
    font-size: 18px;
  }
  h4 {
    font-size: 16px;
  }
  p {
    line-height: 2;
  }
  strong {
    font-weight: 600;
  }
  ol,
  ul {
    color: ${Secondary};
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  li {
    font-weight: 200;
  }
  a {
    color: ${Secondary};
    font-weight: 400;
    text-decoration: underline ${Secondary};
  }
  a:active,
  a:focus {
    color: ${Primary};
  }
  a:hover {
    color: ${Primary};
  }
`

export { articleStyleInEditorContentStyle, articleStyle }
